import React, {CSSProperties, FC} from "react";
import classNames from "classnames";

import {capitalizeTextChildren} from "../utils/capitalize_text_children";
import {TextVariant, TextVariantUnionType} from "../utils/text_variant";

import {
    bodyCopy0,
    bodyCopy1,
    bodyCopy2,
    buttonBig,
    buttonMedium,
    buttonMicro,
    buttonSmall,
    headline0,
    headline1,
    headline2,
    headline3,
    headline4,
    headline5,
    headline6,
    infoTxt1,
    infoTxt2,
    infoTxt3,
    miniHeader,
    noWrapStyle,
    preserveFontSize as preserveFontSizeStyle,
    strongStyle,
    textBase,
    textBasePrimary,
    textBaseSecondary
} from "./Text.module.css";

const defaultVariantMapping: Record<TextVariantUnionType, React.ElementType> = {
    [TextVariant.HEADLINE_0]: "h1",
    [TextVariant.HEADLINE_1]: "h1",
    [TextVariant.HEADLINE_2]: "h2",
    [TextVariant.HEADLINE_3]: "h3",
    [TextVariant.HEADLINE_4]: "h4",
    [TextVariant.HEADLINE_5]: "h5",
    [TextVariant.HEADLINE_6]: "h6",
    [TextVariant.BODY_COPY_0]: "p",
    [TextVariant.BODY_COPY_1]: "p",
    [TextVariant.BODY_COPY_2]: "p",
    [TextVariant.INFO_TXT_1]: "p",
    [TextVariant.INFO_TXT_2]: "p",
    [TextVariant.INFO_TXT_3]: "p",
    [TextVariant.MINI_HEADER]: "span",
    [TextVariant.BUTTON_BIG]: "span",
    [TextVariant.BUTTON_SMALL]: "span",
    [TextVariant.BUTTON_MEDIUM]: "span",
    [TextVariant.BUTTON_MICRO]: "span"
};

type ITextMargin = 0.5 | 1 | 1.5 | 2 | 3 | 3.5 | 4 | 6 | 8;

export interface ITextProps {
    children?: React.ReactNode;
    as?: React.ElementType;
    variant?: TextVariantUnionType;
    capitalize?: boolean;
    noWrap?: boolean;
    /**
     * Locks desktop type-scale metrics (font-size / line-height) on all breakpoints.
     * No-op for non-responsive variants (button_*).
     */
    preserveFontSize?: boolean;
    strong?: boolean;
    color?: string;
    align?: "start" | "center" | "inherit" | "justify" | "left" | "right";
    mb?: ITextMargin;
    fontFamily?: "primary" | "secondary";
    className?: string;
    id?: string;
    onClick?: (e: React.MouseEvent) => void;
    style?: CSSProperties;
    dataTestId?: string;
    dangerouslySetInnerHTML?: {__html: string};
}

export const Text: FC<ITextProps> = (props) => {
    const {
        as,
        variant = TextVariant.BODY_COPY_0,
        capitalize = false,
        noWrap = false,
        preserveFontSize = false,
        strong = false,
        fontFamily = "primary",
        color,
        align,
        mb,
        style = {},
        dangerouslySetInnerHTML
    } = props;

    const DomElement = as || (variant && defaultVariantMapping[variant]) || "span";

    const variantStyle = getTextVariantStyleFor(variant);

    const fontFamilyClass = classNames(
        variantStyle,
        preserveFontSize && preserveFontSizeStyle,
        fontFamily === "primary" ? textBasePrimary : textBaseSecondary,
        strong && strongStyle,
        noWrap && noWrapStyle,
        textBase,
        props.className
    );

    const textColor = color ? {"--text-local-color": color} : {};
    const textAlign = align ? {"--text-local-align": align} : {};
    const marginBottom = mb ? {"--mb-local": `calc(var(--globals-baseUnit) * ${mb})`} : {};
    const children = capitalize && !dangerouslySetInnerHTML ? capitalizeTextChildren(props.children) : props.children;

    return (
        <DomElement
            style={{...textColor, ...textAlign, ...marginBottom, ...style}}
            className={fontFamilyClass}
            onClick={props.onClick}
            id={props.id}
            data-testid={props.dataTestId}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        >
            {children}
        </DomElement>
    );
};

/**
 * return classname to style text outside of Text component
 * @param variant
 */
export const getTextVariantStyleFor = (variant: TextVariantUnionType): string => {
    switch (variant) {
        case TextVariant.HEADLINE_0: {
            return headline0;
        }
        case TextVariant.HEADLINE_1: {
            return headline1;
        }
        case TextVariant.HEADLINE_2: {
            return headline2;
        }
        case TextVariant.HEADLINE_3: {
            return headline3;
        }
        case TextVariant.HEADLINE_4: {
            return headline4;
        }
        case TextVariant.HEADLINE_5: {
            return headline5;
        }
        case TextVariant.HEADLINE_6: {
            return headline6;
        }
        case TextVariant.BODY_COPY_0: {
            return bodyCopy0;
        }
        case TextVariant.BODY_COPY_1: {
            return bodyCopy1;
        }
        case TextVariant.BODY_COPY_2: {
            return bodyCopy2;
        }
        case TextVariant.INFO_TXT_1: {
            return infoTxt1;
        }
        case TextVariant.INFO_TXT_2: {
            return infoTxt2;
        }
        case TextVariant.INFO_TXT_3: {
            return infoTxt3;
        }
        case TextVariant.MINI_HEADER: {
            return miniHeader;
        }
        case TextVariant.BUTTON_BIG: {
            return buttonBig;
        }
        case TextVariant.BUTTON_MEDIUM: {
            return buttonMedium;
        }
        case TextVariant.BUTTON_SMALL: {
            return buttonSmall;
        }
        case TextVariant.BUTTON_MICRO: {
            return buttonMicro;
        }
    }
};
import React, {CSSProperties, FC} from "react";
import classNames from "classnames";

import {capitalizeTextChildren} from "../utils/capitalize_text_children";
import {TextVariant, TextVariantUnionType} from "../utils/text_variant";

import {
    bodyCopy0,
    bodyCopy1,
    bodyCopy2,
    buttonBig,
    buttonMedium,
    buttonMicro,
    buttonSmall,
    headline0,
    headline1,
    headline2,
    headline3,
    headline4,
    headline5,
    headline6,
    infoTxt1,
    infoTxt2,
    infoTxt3,
    miniHeader,
    noWrapStyle,
    preserveFontSize as preserveFontSizeStyle,
    strongStyle,
    textBase,
    textBasePrimary,
    textBaseSecondary
} from "./Text.module.css";

const defaultVariantMapping: Record<TextVariantUnionType, React.ElementType> = {
    [TextVariant.HEADLINE_0]: "h1",
    [TextVariant.HEADLINE_1]: "h1",
    [TextVariant.HEADLINE_2]: "h2",
    [TextVariant.HEADLINE_3]: "h3",
    [TextVariant.HEADLINE_4]: "h4",
    [TextVariant.HEADLINE_5]: "h5",
    [TextVariant.HEADLINE_6]: "h6",
    [TextVariant.BODY_COPY_0]: "p",
    [TextVariant.BODY_COPY_1]: "p",
    [TextVariant.BODY_COPY_2]: "p",
    [TextVariant.INFO_TXT_1]: "p",
    [TextVariant.INFO_TXT_2]: "p",
    [TextVariant.INFO_TXT_3]: "p",
    [TextVariant.MINI_HEADER]: "span",
    [TextVariant.BUTTON_BIG]: "span",
    [TextVariant.BUTTON_SMALL]: "span",
    [TextVariant.BUTTON_MEDIUM]: "span",
    [TextVariant.BUTTON_MICRO]: "span"
};

type ITextMargin = 0.5 | 1 | 1.5 | 2 | 3 | 3.5 | 4 | 6 | 8;

export interface ITextProps {
    children?: React.ReactNode;
    as?: React.ElementType;
    variant?: TextVariantUnionType;
    capitalize?: boolean;
    noWrap?: boolean;
    /**
     * Locks desktop type-scale metrics (font-size / line-height) on all breakpoints.
     * No-op for non-responsive variants (button_*).
     */
    preserveFontSize?: boolean;
    strong?: boolean;
    color?: string;
    align?: "start" | "center" | "inherit" | "justify" | "left" | "right";
    mb?: ITextMargin;
    fontFamily?: "primary" | "secondary";
    className?: string;
    id?: string;
    onClick?: (e: React.MouseEvent) => void;
    style?: CSSProperties;
    dataTestId?: string;
    dangerouslySetInnerHTML?: {__html: string};
}

export const Text: FC<ITextProps> = (props) => {
    const {
        as,
        variant = TextVariant.BODY_COPY_0,
        capitalize = false,
        noWrap = false,
        preserveFontSize = false,
        strong = false,
        fontFamily = "primary",
        color,
        align,
        mb,
        style = {},
        dangerouslySetInnerHTML
    } = props;

    const DomElement = as || (variant && defaultVariantMapping[variant]) || "span";

    const variantStyle = getTextVariantStyleFor(variant);

    const fontFamilyClass = classNames(
        variantStyle,
        preserveFontSize && preserveFontSizeStyle,
        fontFamily === "primary" ? textBasePrimary : textBaseSecondary,
        strong && strongStyle,
        noWrap && noWrapStyle,
        textBase,
        props.className
    );

    const textColor = color ? {"--text-local-color": color} : {};
    const textAlign = align ? {"--text-local-align": align} : {};
    const marginBottom = mb ? {"--mb-local": `calc(var(--globals-baseUnit) * ${mb})`} : {};
    const children = capitalize && !dangerouslySetInnerHTML ? capitalizeTextChildren(props.children) : props.children;

    return (
        <DomElement
            style={{...textColor, ...textAlign, ...marginBottom, ...style}}
            className={fontFamilyClass}
            onClick={props.onClick}
            id={props.id}
            data-testid={props.dataTestId}
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
        >
            {children}
        </DomElement>
    );
};

/**
 * return classname to style text outside of Text component
 * @param variant
 */
export const getTextVariantStyleFor = (variant: TextVariantUnionType): string => {
    switch (variant) {
        case TextVariant.HEADLINE_0: {
            return headline0;
        }
        case TextVariant.HEADLINE_1: {
            return headline1;
        }
        case TextVariant.HEADLINE_2: {
            return headline2;
        }
        case TextVariant.HEADLINE_3: {
            return headline3;
        }
        case TextVariant.HEADLINE_4: {
            return headline4;
        }
        case TextVariant.HEADLINE_5: {
            return headline5;
        }
        case TextVariant.HEADLINE_6: {
            return headline6;
        }
        case TextVariant.BODY_COPY_0: {
            return bodyCopy0;
        }
        case TextVariant.BODY_COPY_1: {
            return bodyCopy1;
        }
        case TextVariant.BODY_COPY_2: {
            return bodyCopy2;
        }
        case TextVariant.INFO_TXT_1: {
            return infoTxt1;
        }
        case TextVariant.INFO_TXT_2: {
            return infoTxt2;
        }
        case TextVariant.INFO_TXT_3: {
            return infoTxt3;
        }
        case TextVariant.MINI_HEADER: {
            return miniHeader;
        }
        case TextVariant.BUTTON_BIG: {
            return buttonBig;
        }
        case TextVariant.BUTTON_MEDIUM: {
            return buttonMedium;
        }
        case TextVariant.BUTTON_SMALL: {
            return buttonSmall;
        }
        case TextVariant.BUTTON_MICRO: {
            return buttonMicro;
        }
    }
};
